export default __webpack_public_path__ + "static/media/t-shirt.6d43ff07.png";